import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Modal } from "react-bootstrap";
import React from "react";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { ButtonVariant } from "react-bootstrap/esm/types";

export type ButtonOptions = {
    title: string;
    icon: IconProp;
    variant: ButtonVariant
}

type QuestionProps = {
    show: boolean;
    title?: React.ReactNode;
    message: React.ReactNode;
    onClose: (confirmed: boolean) => void;
    buttonConfirmOptions: ButtonOptions;
    buttonCancelOptions: ButtonOptions;
    buttonCancelShow: boolean;
}

export const ModalQuestion: React.FC<QuestionProps> = ({ show, title, message, onClose, buttonConfirmOptions, buttonCancelOptions, buttonCancelShow }) => {
    const handleConfirm = () => onClose(true);
    const handleCancel = () => onClose(false);

    return (<Modal show={show} onHide={handleCancel} centered
        keyboard={buttonCancelShow}
        backdrop='static'>
        {title && <Modal.Header closeButton={buttonCancelShow} className=" py-1">
            <Modal.Title>{title}</Modal.Title>
        </Modal.Header>}
        <Modal.Body>{message}</Modal.Body>
        <Modal.Footer className="d-flex justify-content-between py-1">
            {buttonCancelShow ? (
                <Button variant={buttonCancelOptions.variant} 
                    onClick={handleCancel} style={{ minWidth: '8rem' }} title="[ESC] paa cancelar">
                    <FontAwesomeIcon icon={buttonCancelOptions.icon} />&nbsp;
                    {buttonCancelOptions.title}</Button>
            ) : <div></div>}
            <Button variant={buttonConfirmOptions.variant}
                onClick={handleConfirm} style={{ minWidth: '8rem' }}>
                <FontAwesomeIcon icon={buttonConfirmOptions.icon} />&nbsp;
                {buttonConfirmOptions.title}
            </Button>
        </Modal.Footer>
    </Modal>)
}